import React, { useState } from 'react';
import { AmButton, MonoTag } from './shared';

const NavRow: React.FC<{
  step: number;
  canAdvance: boolean;
  prevDisabled?: boolean;
  loading?: boolean;
  hint: string;
  phone?: boolean;
  showHint?: boolean;
  onPrev: () => void;
  onNext: () => void;
}> = ({
  step,
  canAdvance,
  prevDisabled = false,
  loading = false,
  hint,
  phone,
  showHint,
  onPrev,
  onNext,
}) => {
  const isFirst = step === 0;
  const isLast = step === 4;
  const [prevHover, setPrevHover] = useState(false);
  const prevActive = prevHover && !prevDisabled;
  return (
    <div
      style={{
        borderTop: '1px solid #383838',
        padding: phone ? '16px 20px' : '20px 56px',
        display: 'flex',
        alignItems: 'center',
        gap: phone ? 12 : 24,
        flexShrink: 0,
      }}
    >
      <button
        onClick={onPrev}
        disabled={prevDisabled}
        onMouseEnter={() => setPrevHover(true)}
        onMouseLeave={() => setPrevHover(false)}
        style={{
          background: prevActive ? 'rgba(240,132,22,.22)' : 'transparent',
          border: `1px solid ${prevDisabled ? '#383838' : '#f08416'}`,
          color: prevDisabled ? '#787878' : '#f08416',
          height: 44,
          padding: '0 20px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'Kanit',
          fontSize: 12,
          letterSpacing: '.18em',
          textTransform: 'uppercase',
          cursor: prevDisabled ? 'not-allowed' : 'pointer',
          boxShadow: prevActive ? '0 0 16px rgba(240,132,22,.35)' : 'none',
          transform: prevActive ? 'translateY(-1px)' : 'none',
          transition: 'background .12s, box-shadow .12s, transform .1s',
        }}
      >
        {isFirst ? '← Login' : '← Previous'}
      </button>
      <div style={{ flex: 1, textAlign: 'center' }}>
        {showHint && <MonoTag color="#787878">{hint || ''}</MonoTag>}
      </div>
      <AmButton disabled={!canAdvance || loading} onClick={onNext}>
        {loading
          ? 'Please wait…'
          : isLast
          ? 'Enter the App →'
          : `Continue → ${String(step + 2).padStart(2, '0')}`}
      </AmButton>
    </div>
  );
};

export default NavRow;
